import { cn } from '@/lib/utils/cn';

interface DividerProps {
  direction?: 'horizontal' | 'vertical';
  className?: string;
}

export function Divider({ direction = 'horizontal', className }: DividerProps) {
  return (
    <div
      role="separator"
      className={cn(
        'bg-gray-300 shrink-0',
        direction === 'vertical' ? 'w-px self-stretch' : 'h-px w-full',
        className,
      )}
    />
  );
}
